/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Drive_Not_ConnectedInputs */

const fr_api_drive_not_connected = /** @type {(inputs: Api_Drive_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez Google Drive pour continuer.`)
};

const en_api_drive_not_connected = /** @type {(inputs: Api_Drive_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Google Drive to continue.`)
};

/**
* | output |
* | --- |
* | "Connect Google Drive to continue." |
*
* @param {Api_Drive_Not_ConnectedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_drive_not_connected = /** @type {((inputs?: Api_Drive_Not_ConnectedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Drive_Not_ConnectedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_drive_not_connected(inputs)
	return fr_api_drive_not_connected(inputs)
});